
import React from 'react';
import ReactTable from "react-table";
import { loadAllWlf } from "./actions";
import {bpsToString, dollarToString} from '../../../lib/currency-utils';
import { Link } from 'react-router-dom';
import { ADVISORY_FEE, SUB_ADVISORY_FEE } from "../../../lib/constants";
import PDFViewer from "../../components/pdfViewer";
import { is_uuid } from "../../../lib/uuid";

class SA_Wlf extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      wlfs: null,
      wlf: null,
      pdfItems: null,
      view_pdf_url: null,
    }
  }

  componentDidMount = () => {
    if (!this.state.wlfs) {

      loadAllWlf(this.props.token)
        .then(({wlfs, pdfItems}) => {
          this.setState({
            wlfs,
            pdfItems,
          });
        });
    }
  };

  bpsClick = (item, fee_type) => event => {
    let newState = {
      bpsType: fee_type,
      showBpsDialog: true,
      editId: item.id,
    };

    if (fee_type === ADVISORY_FEE) {
      newState.bpsString = bpsToString(item.advisory_fee);
      newState.bpsTitle = "Update Advisory Fee";
    } else {
      newState.bpsString = bpsToString(item.sub_advisory_fee);
      newState.bpsTitle = "Update Sub Advisory Fee";
    }
    this.setState(newState);
  };

  renderWLCell = (row) => {
    const wlf_id = row.original.id;
    if (is_uuid(wlf_id)) {
      return (<span>{row.row._original.name}</span>);
    }
    const url = "/super-admin/wlf/" + wlf_id;
    return (<Link to={url}>{row.row._original.name}</Link>);
  };

  renderAddress = item => {
    const address = item.original.info.address;
    let addrList = address.map((line, index) => (
      <p key={index}>{line}</p>
    ));
    return (
      <div>
        { addrList }
      </div>
    );
  };

  genBPS = (item, fee_type) => {
    let bpsStr = fee_type === ADVISORY_FEE
      ? bpsToString(item.advisory_fee) : bpsToString(item.sub_advisory_fee);
    return (
      <div onClick={this.bpsClick(item, fee_type)}>
        { bpsStr }
      </div>);
  };

  openPdfViewer = url => {
    this.setState({
      view_pdf_url: url,
    })
  };

  closePdfViewer = () => {
    this.setState({
      view_pdf_url: null,
    })
  };

  renderPdfViewer = () => {
    return(
      <PDFViewer url={"/assets/pdf/?u=" + this.state.view_pdf_url + "&v=y"}
                 onClose={this.closePdfViewer}/>
    )
  };

  genPdfCell = (item) => {

    if (item) {
      return (
        <div className='has-text-centered'>
          <a onClick={event => this.openPdfViewer(item)}>
          <span className="icon is-medium">
            <i className="far fa-file-pdf"/>
          </span>
            <span>PDF</span>
          </a>
        </div>
      );
    }

    return (
      <div className='has-text-centered'>
        <span>PDF</span>
      </div>
    );
  };

  renderCSSCell = row => {
    const url = "/super-admin/css-editor/" + row.id;
    const style = {
      marginTop: "0.5rem",
    };
    return (
      <div className='has-text-centered' style={style}>
        <Link to={url}>CSS</Link>
      </div>);
  };

  maybeRenderTable = () => {

    if (!this.state.wlfs) {
      return null;
    }

    const wlfs = this.state.wlfs;

    return (
      <div className="data-table">
        <ReactTable
          data = {wlfs}
          pageSize = {wlfs.length}
          showPagination={false}
          className="-striped -highlight"
          columns={[
            {
              Header: "Wlf Name",
              id: "name",
              Cell: this.renderWLCell
            },
            {
              Header: "Phone",
              id: "phone",
              accessor: item => item.info.phone
            },
            {
              Header: "Address",
              id: "address",
              Cell: this.renderAddress
            },
            {
              Header: "Advisory Fee (bps)",
              id: "advisory",
              accessor: item => item,
              Cell: row => this.genBPS(row.value, ADVISORY_FEE),
            },
            {
              Header: "Sub Advisory Fee (bps)",
              id: "sub_advisory",
              accessor: item => item,
              Cell: row => this.genBPS(row.value, SUB_ADVISORY_FEE),
            },
            {
              Header: "Total Balance",
              id: "total_balance",
              accessor: item => dollarToString(item.total),
            },
            {
              Header: "Disclosures",
              id: "disclosures",
              accessor: item => item.disclosures,
              Cell: row => this.genPdfCell(row.value)
            },
            {
              Header: "Online Privacy",
              id: "online_privacy",
              accessor: item => item.online_privacy,
              Cell: row => this.genPdfCell(row.value)
            },
            {
              Header: "Terms and Conditions",
              id: "toc",
              accessor: item => item.toc,
              Cell: row => this.genPdfCell(row.value)
            },
            {
              Header: "Css Table",
              id: "css",
              accessor: item => item,
              Cell: row => this.renderCSSCell(row.value),
            }
          ]}
        />
      </div>
    );
  };

  render = () => {
    const show_pdf = !!this.state.view_pdf_url;

    return (
      <section className="section">
        { /* this.maybeShowBpsDialog() */ }
        <div className="container">
          { this.maybeRenderTable() }
        </div>
        { show_pdf && this.renderPdfViewer() }
      </section>
    )
  }
}

export { SA_Wlf };
